import EmblaCarousel from 'embla-carousel';
import {Fancybox} from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import {ruFancybox} from './utils';
import {api} from './api';

const addImageThumbClickHandlers = (emblaApiMain, emblaApiThumb) => {
    const slidesThumbs = emblaApiThumb.slideNodes();

    const scrollToIndex = slidesThumbs.map((_, index) => () => emblaApiMain.scrollTo(index));

    slidesThumbs.forEach((slideNode, index) => {
        slideNode.addEventListener('click', scrollToIndex[index], false);
    });

    return () => {
        slidesThumbs.forEach((slideNode, index) => {
            slideNode.removeEventListener('click', scrollToIndex[index], false);
        });
    };
};

const addToggleImageThumbActive = (emblaApiMain, emblaApiThumb) => {
    const slidesThumbs = emblaApiThumb.slideNodes();

    const toggleThumbState = () => {
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
        const previous = emblaApiMain.previousScrollSnap();
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[previous].classList.remove('product-detail__image-thumb--active');
        slidesThumbs[selected].classList.add('product-detail__image-thumb--active');
    };

    emblaApiMain.on('select', toggleThumbState);
    emblaApiThumb.on('init', toggleThumbState);

    return () => {
        const selected = emblaApiMain.selectedScrollSnap();

        slidesThumbs[selected].classList.remove('product-detail__image-thumb--active');
    };
};

const addDotClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = [];

    const addDotWithClickHandlers = () => {
        dotsNode.innerHTML = emblaApi
            .scrollSnapList()
            .map(
                () =>
                    '<button class="product-detail__image-slider-dot" type="button" title="Переключить"><span class="visually-hidden">Переключить</span></button>'
            )
            .join('');

        dotNodes = Array.from(dotsNode.querySelectorAll('.product-detail__image-slider-dot'));

        dotNodes.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false);
        });
    };

    const toggleDotActive = () => {
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove('product-detail__image-slider-dot--active');
        dotNodes[selected].classList.add('product-detail__image-slider-dot--active');
    };

    emblaApi
        .on('init', addDotWithClickHandlers)
        .on('reInit', addDotWithClickHandlers)
        .on('init', toggleDotActive)
        .on('reInit', toggleDotActive)
        .on('select', toggleDotActive);

    return () => {
        dotsNode.innerHTML = '';
    };
};

const OPTIONS = {};

const OPTIONS_THUMBS = {
    containScroll: false,
    dragFree: false,
    watchDrag: false,
};

const sliderInit = () => {
    const sliderWrapperElement = document.querySelector('.product-detail__image-slider-wrapper');

    if (sliderWrapperElement) {
        const imageThumbsWrapperElement = document.querySelector('.product-detail__image-thumbs-wrapper');

        const emblaApiMain = EmblaCarousel(sliderWrapperElement, OPTIONS);
        const emblaApiThumb = EmblaCarousel(imageThumbsWrapperElement, OPTIONS_THUMBS);

        const removeImageThumbClickHandlers = addImageThumbClickHandlers(emblaApiMain, emblaApiThumb);

        const removeToggleImageThumbActive = addToggleImageThumbActive(emblaApiMain, emblaApiThumb);

        emblaApiMain.on('destroy', removeImageThumbClickHandlers).on('destroy', removeToggleImageThumbActive);

        emblaApiThumb.on('destroy', removeImageThumbClickHandlers).on('destroy', removeToggleImageThumbActive);

        if (window.innerWidth < 1024) {
            const dotsElement = document.querySelector('.product-detail__image-slider-dots');

            addDotClickHandlers(emblaApiMain, dotsElement);
        }
    }
};

const fancyboxInit = () => {
    Fancybox.bind('[data-fancybox="product-slider"]', {
        l10n: ruFancybox,
        Images: {
            zoom: false,
        },
        hideScrollbar: false,
        idle: 10000,
    });
};

/**
 * @param amount
 * @returns {string}
 */
const getIdentificationByAmount = (amount) => {
    switch (true) {
        case amount >= 0 && amount < 100:
            return `${amount}`;
        case amount > 100:
            return '> 100 шт';
        default:
            return '0';
    }
};

/**
 * @param availableStocks
 * @param stocksByOrder
 */
const updateStoreAmountIdentifications = ({availableStocks, stocksByOrder}) => {
    const totalAmountElement = document.querySelector('[data-entity="total-amount"]');
    const totalRequestAmountElement = document.querySelector('[data-entity="total-request-amount"]');

    totalAmountElement.textContent = getIdentificationByAmount(availableStocks);
    totalRequestAmountElement.textContent = getIdentificationByAmount(stocksByOrder);
};

/**
 * @param productId
 * @returns {Promise<void>}
 */
const getStoreAmountById = (productId) => {
    api.get(`store/product-amount/${productId}`)
        .then((response) => response.json())
        .then((data) => {
            if (!data.status) {
                return;
            }

            updateStoreAmountIdentifications({
                availableStocks: data?.availableStocks,
                stocksByOrder: data?.stocksByOrder,
            });
        })
        .catch(async (error) => {
            const errorMessage = await error.response.json();

            console.error(errorMessage.message);
        });
};

const storeAmountInit = () => {
    const wrapperElement = document.querySelector('[data-entity="store-amount-wrapper"]');

    if (wrapperElement) {
        const productId = document.querySelector('[data-product-card-id]').dataset.productCardId;

        getStoreAmountById(productId);
    }
};

const characteristicsBlockInit = () => {
    const characteristicsTriggerElement = document.querySelector('.product-detail__characteristics-trigger');
    const characteristicsListElement = document.querySelector('.product-detail__characteristics-list');

    if (characteristicsTriggerElement && characteristicsListElement) {
        characteristicsTriggerElement.addEventListener('click', () => {
            characteristicsTriggerElement.classList.toggle('product-detail__characteristics-trigger--active');

            characteristicsListElement.classList.toggle('product-detail__characteristics-list--active');
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    sliderInit();
    fancyboxInit();
    characteristicsBlockInit();

    setTimeout(() => {
        storeAmountInit();
    }, 200);
});
